<template>
  <div id="app" ref="app">
    <router-view></router-view>
  </div>
</template>

<script>
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
export default {
  name: 'app',
  mounted () {
    window.onresize = () => {
      return (() => {
        let clientWidth = document.body.clientWidth
        document.documentElement.style.fontSize = clientWidth / 16 + 'px'
      })()
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size:0.75rem;
  color: #333333; 
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// App.vue?b62b5872